import { render, staticRenderFns } from "./CellRendererTransactionIDReg.vue?vue&type=template&id=2928f2ad&"
import script from "./CellRendererTransactionIDReg.vue?vue&type=script&lang=js&"
export * from "./CellRendererTransactionIDReg.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererTransactionIDReg.vue?vue&type=style&index=0&id=2928f2ad&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports